module.exports = __webpack_public_path__ + "static/Shojumaru-e4041fb90d6d65514d29edd909c3feca.woff";